import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../../../services/authentication.service';

@Component({
  selector: 'app-side-stepper',
  templateUrl: './side-stepper.component.html',
  styleUrl: './side-stepper.component.less'
})
export class SideStepperComponent {
  profileuUrl : string = '';
  @Input() activeStep : string = '';
  pendingStep: string | null = null;
  usersInitial: string = '';
  hoveredStep: string | null = null;
  getGenericSettings: any;
  // activeStep : string = 'offer'
  steps : any = [
    { key: 'dashboard', value: 'Dashboard', img : 'assets/images/icons/dashboard.png' ,activeImg : 'assets/images/icons/dashboard.png' , showTab: true },
    { key: 'locations', value: 'Locations', img : 'assets/images/icons/location_pin.png', activeImg:'assets/images/icons/locations_active.png', showTab: true },
    { key: 'offers', value: 'Offers', img : 'assets/images/icons/award.png', activeImg:'assets/images/icons/offers_active.png', showTab: true },
    { key: 'profile', value: 'Profile', img : 'assets/images/icons/profile_tag.png', activeImg:'assets/images/icons/profile_active.png', showTab: true },
    { key: 'payments', value: 'Invoices and Payments', img : 'assets/images/icons/invoices.png', activeImg:'assets/images/icons/invoices_active.png', showTab: true }, 
    { key: 'transactions', value: 'Transactions', img : 'assets/images/icons/transactions.png', activeImg:'assets/images/icons/transactions_active.png', showTab: true },  
  ]

  activeTooltipKey: string | null = null;

  constructor(
    private router: Router,
    private authenticationService : AuthenticationService
  ) {
    this.getGenericSettings = JSON.parse(localStorage.getItem('portalGenericSettings') || '{}');
  }
  ngOnInit(): void {
    this.getUserInitial();
    this.steps = [
      // { key: 'dashboad', value: 'Dashboard', img : 'assets/images/icons/dashboard.png' },
      { key: 'dashboard', value: 'Dashboard', img : 'assets/images/icons/dashboard.png' ,activeImg : 'assets/images/icons/dashboard.png' , showTab: this.getGenericSettings.showDashboardTab },
      { key: 'locations', value: 'Locations', img : 'assets/images/icons/location_pin.png', activeImg:'assets/images/icons/locations_active.png', showTab: this.getGenericSettings.showLocationsTab },
      { key: 'offers', value: 'Offers', img : 'assets/images/icons/award.png', activeImg:'assets/images/icons/offers_active.png', showTab: this.getGenericSettings.showOffersTab },
      { key: 'profile', value: 'Profile', img : 'assets/images/icons/profile_tag.png', activeImg:'assets/images/icons/profile_active.png', showTab: this.getGenericSettings.showProfileTab },
      { key: 'payments', value: 'Invoices and Payments', img : 'assets/images/icons/invoices.png', activeImg:'assets/images/icons/invoices_active.png', showTab: this.getGenericSettings.showPaymentInvoicesTab }, 
      { key: 'transactions', value: 'Transactions', img : 'assets/images/icons/transactions.png', activeImg:'assets/images/icons/transactions_active.png', showTab: this.getGenericSettings.showTransactionsTab },  
    ]
  }

  getVisibleSteps() {
    return this.steps.filter((step: any) => step.showTab);
  }
  
  getUserInitial(){
    if((this.authenticationService.currentUser.value.user.first_name && this.authenticationService.currentUser.value.user.first_name!=='') || (this.authenticationService.currentUser.value.user.last_name && this.authenticationService.currentUser.value.user.last_name!=='')){
      this.usersInitial = 
      (this.authenticationService.currentUser.value.user.first_name?.charAt(0).toUpperCase() || '') +
      (this.authenticationService.currentUser.value.user.last_name?.charAt(0).toUpperCase() || '');  
    }else{
      this.profileuUrl='assets/images/icons/header_person_logo.png';
    }
  }
  navigate(stepKey: string) {
    this.pendingStep = stepKey; // Set the pending step

    // Assuming your `canDeactivate` guard has been properly integrated in the routing
    this.router.navigate([stepKey]).then((navigationSuccess: boolean) => {
      if (navigationSuccess) {
        // Update active step only if navigation was successful
        this.activeStep = this.pendingStep ?? '';
      }
      // Reset pendingStep whether navigation was successful or not
      this.pendingStep = null;
    });
  }

  showTooltip(event: MouseEvent, presentStep: any) {
    this.activeTooltipKey = this.steps.find((step:any) => step.value === presentStep.value)?.key || null;
    this.hoveredStep = presentStep.key;
  }

  hideTooltip() {
    this.activeTooltipKey = null;
    this.hoveredStep = null;
  }
}
